import { computed } from 'vue'
import { useSwipe } from '@vueuse/core'

export default {
  setSwipe(top, onSwipeEnd, target, container, topValue, minMovement) {
    const containerHeight = computed(() => {
      return container ? container.offsetHeight : 0
    })
    const isMobile = computed(() => {
      return window.getComputedStyle(container, null).position === 'fixed'
    })

    const { lengthY } = useSwipe(
      target, {
        passive: true,
        onSwipe() {
          if (isMobile.value) {
            if (lengthY.value < minMovement) {
              const length = Math.abs(lengthY.value)
              top.value = `${length + topValue}`
            } else {
              top.value = topValue
            }
          }
        },
        onSwipeEnd() {
          if (isMobile.value) {
            if (lengthY.value < 0 && Math.abs(lengthY.value) > containerHeight.value / 3) {
              onSwipeEnd()
            } else {
              top.value = topValue
            }
          }
        }
      })
  }
}
